<template>
  <VView class="contest-winners" back-button-to="/menu" header="Laureaci">
    <VText center><small><span>Lot w tunelu</span><br />
    Szymon Przegenda</small></VText>

    <VText center><small><span>Construction Playset</span><br />
    Antoni Mielniczuk<br />
    Filip Nowacki<br />
    Gracja Wnęk</small></VText>

    <VText center><small><span>Weight Lift Excavator</span><br />
    Kasia Pokrzyk <br />
    Piotr Żmuda<br />
    Filip Kamiński</small></VText>

    <VText center><small><span>Micro Workers</span><br />
    Karolina Gołuchowska<br />
    Bartosz  Murzynowski <br />
    Kajetan Pawlik<br />
    Jan Dźwiniel<br />
    Miłosz Franas<br />
    Tymek Cygan<br />
    Ignacy Cichy<br />
    Mateusz  Zaręba <br />
    Szymon Kruczek<br />
    Irena Marcinkowska<br />
    Jan Weremczuk<br />
    Mateusz Pociej<br />
    Natalia Brzozowska<br />
    Gaja  Cierzniak</small></VText>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VMedia from '@/components/VMedia.vue';
import VText from '@/components/VText.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'ContestWinners',
  components: {
    VView,
    VMedia,
    VText,
    VButton,
    VButtonGroup,
  },
};
</script>

<style lang="scss" scoped>
.contest-winners {
  &__picture {
    margin: 100px auto 50px;
  }
}
</style>
